const REGISTRATION_FIELDS = {
  EMAIL: 'email',
  PHONE: 'phone',
  FIRST_NAME: 'first_name',
  LAST_NAME: 'last_name',
  PASSWORD: 'password',
  REPEAT_PASSWORD: 'repeat_password',
  IS_AGENT_CHECKBOX: 'isAgentCheckbox',
  COMPANY_NAME: 'company_name',
  LICENSE_NUMBER: 'license_number',
  COUPON: 'coupon',
  LOGO: 'logo',
  AGREE: 'agree',
  CODE: 'code',
  VECHIR_V_HATU: 'vechir_v_hatu'
};

export default REGISTRATION_FIELDS;
